// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/@master/webinfra-frontend-components/src/components/Tabs/Tabs.less
// module id = 1061
// module chunks = 0